import { DeliveryPickupType } from '@/view-models/delivery'

/**
 * @param {import('vue').Ref<{
 *    address: string
 *    establishment: string
 *    floor_building_number: string
 *    lat: number
 *    lng: number
 *    note: string
 *    pickup_type: DeliveryPickupType
 *  }>} deliveryInfo
 */
export function useDeliveryCommentNote(deliveryInfo = ref({})) {
  const { $i18n } = useNuxtApp()
  const pickupTypeTextMap = ref({
    [DeliveryPickupType.MeetOutside]: $i18n.t('take_meal_in_person'),
    [DeliveryPickupType.PutOnDoor]: $i18n.t('take_meal_on_door'),
    [DeliveryPickupType.MeetInside]: $i18n.t('take_meal_at_door'),
  })
  const pickTypeText = computed(() => pickupTypeTextMap.value[deliveryInfo.value.pickup_type])
  const noteText = computed(() =>
    [deliveryInfo.value.floor_building_number, deliveryInfo.value.establishment, pickTypeText.value, deliveryInfo.value.note]
      .filter(Boolean)
      .join(', ')
  )

  return {
    noteText,
  }
}
